import React, { Fragment } from 'react'
import MEModal from '../../components/MEModal'
import { FormGroup, ControlLabel, Button, MenuItem } from 'react-bootstrap'
import ButterToast, { Cinnamon } from 'butter-toast'
import { setExpirationDate } from '../actions'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

class SetExpirationModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      setExpirationDateModalOpen: false,
      expirationDate: new Date().toISOString().split('T')[0],
    }
    this.toggleSetExpirationDateModal =
      this.toggleSetExpirationDateModal.bind(this)
    this.handleSetExpirationDate = this.handleSetExpirationDate.bind(this)
    this.submitExpirationDate = this.submitExpirationDate.bind(this)
  }

  toggleSetExpirationDateModal() {
    this.setState({
      setExpirationDateModalOpen: !this.state.setExpirationDateModalOpen,
    })
  }

  handleSetExpirationDate(e) {
    this.setState({
      expirationDate: e.target.value,
    })
  }

  async submitExpirationDate() {
    let data = {
      section_id: this.props.section,
      expiration_date: this.state.expirationDate,
    }
    let response = await this.props.sendExpirationDate(data)
    this.toggleSetExpirationDateModal()
    if (response.status === 200) {
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Expiration Date Added"
            content="Successfully added a new expiration date for this section."
            scheme={Cinnamon.Crisp.SCHEME_GREY}
          />
        ),
      })
    } else {
      let error = response.error
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Error"
            content={error}
            scheme={Cinnamon.Crisp.SCHEME_RED}
          />
        ),
      })
    }
  }

  render() {
    return (
      <Fragment>
        <MenuItem
          onClick={this.toggleSetExpirationDateModal}
          className="me-list-item"
        >
          <div className="fal fa-stopwatch mr-2 color_teal fa-fw" />
          Set Expiration Date
        </MenuItem>
        <MEModal
          show={this.state.setExpirationDateModalOpen}
          close={this.toggleSetExpirationDateModal}
          title="Set Section Expiration Date"
        >
          <form onSubmit={e => e.preventDefault()}>
            <p>
              Select a date and time below. You can remove an expiration date by
              clicking submit without filling in the expiration field.
            </p>
            <FormGroup>
              <ControlLabel>Expiration Date</ControlLabel>
              <input
                className="form-control"
                type="date"
                placeholder="YYYY/MM/DD"
                value={this.state.expirationDate}
                onChange={this.handleSetExpirationDate}
              />
            </FormGroup>
            <Button
              className="btn-myed btn-primary-myed"
              type="button"
              bsStyle="primary"
              onClick={this.submitExpirationDate}
            >
              Submit
            </Button>
          </form>
        </MEModal>
      </Fragment>
    )
  }
}

SetExpirationModal.propTypes = {
  section: PropTypes.string,
  rowData: PropTypes.array,
  sendExpirationDate: PropTypes.func,
  expiration: PropTypes.string,
}

const mapStateToProps = state => {
  return {
    rowData: state.sectionRowData,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    sendExpirationDate: sectionData => {
      let response = dispatch(setExpirationDate(sectionData))
      return response
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SetExpirationModal)
